import { useState, useRef, useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { User, LogOut, Building, IdCard, Briefcase } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import logo from "@/assets/logo.png";

import { ficharService } from "@/services/ficharService";
import { clearSession } from "@/lib/session";

interface PerfilProps {
  userData: any;
}

const Perfil = ({ userData }: PerfilProps) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [dataEmployee, setDataEmployee] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    const load = async () => {
      try {
        const dataEmployee: any = await ficharService.getDataEmployee(userData.id);
        setDataEmployee(dataEmployee.response);
        setLoading(false);
      } catch (e) {
        console.error("Error en carga inicial", e);
      }
    };
    load();
  }, [userData.id]);

  const handleLogout = async () => {
    await clearSession();
    await ficharService.updateApkId({
      id: userData.id,
      idapk: '',
      app_so: ''
    });
    toast({
      title: "Sesión cerrada",
      description: "Has cerrado sesión correctamente",
    });
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  if(loading){
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-white dark:bg-gray-900 z-50">
        <img
          src={logo}
          alt="Logo"
          className="h-20 w-auto mb-6"
        />
        <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-500 text-sm">Cargando...</p>
      </div>
    );
  }

return (
    <div className="space-y-6 animate-fade-in">
      <Card className="border-0 shadow-lg">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <div>
              <CardTitle className="text-xl xs:text-2xl">Mi Perfil</CardTitle>
              <CardDescription className="text-sm xs:text-base mt-0.5">
                Tu información personal
              </CardDescription>
            </div>
            <User className="w-7 h-7 xs:w-8 xs:h-8 text-primary shrink-0" />
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 rounded-xl bg-muted/30">
              <User className="w-4 h-4 xs:w-5 xs:h-5 text-primary mt-0.5 shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs xs:text-sm text-muted-foreground">Nombre completo</p>
                <p className="text-sm xs:text-base font-semibold truncate">
                  {dataEmployee.firstname} {dataEmployee.lastname}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 rounded-xl bg-muted/30">
              <IdCard className="w-4 h-4 xs:w-5 xs:h-5 text-primary mt-0.5 shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs xs:text-sm text-muted-foreground">CIF/NIF</p>
                <p className="text-sm xs:text-base font-semibold">{dataEmployee.cifnif}</p>
              </div>
            </div>

            {dataEmployee.turn_name && (
              <div className="flex items-start gap-3 p-3 rounded-xl bg-muted/30">
                <Briefcase className="w-4 h-4 xs:w-5 xs:h-5 text-primary mt-0.5 shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs xs:text-sm text-muted-foreground">Turno</p>
                  <p className="text-sm xs:text-base font-semibold truncate">{dataEmployee.turn_name}</p>
                </div>
              </div>
            )}

            {dataEmployee.company_name && (
              <div className="flex items-start gap-3 p-3 rounded-xl bg-muted/30">
                <Building className="w-4 h-4 xs:w-5 xs:h-5 text-primary mt-0.5 shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs xs:text-sm text-muted-foreground">Empresa</p>
                  <p className="text-sm xs:text-base font-semibold truncate">{dataEmployee.company_name}</p>
                </div>
              </div>
            )}
          </div>

          <Button
            onClick={handleLogout}
            variant="destructive"
            size="lg"
            className="w-full text-sm xs:text-base font-semibold h-11 xs:h-12 shadow-lg hover:shadow-xl transition-all"
          >
            <LogOut className="w-4 h-4 xs:w-5 xs:h-5 mr-2" />
            Cerrar sesión
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Perfil;